import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { FormSubmitValues } from 'utils/formValidation'

import { TransactionReverseForm } from './TransactionReverseForm'

export interface TransactionReverseFormValues {
  amount: number
  comment: string | null
}

interface OuterProps {
  transaction: TransactionDto

  onSubmit(values: FormSubmitValues<TransactionReverseFormValues>): Promise<void>
}

export const WalletTransactionReverseForm: React.FC<OuterProps> = (props) => {
  const { transaction } = props
  const amount = transaction?.walletTransactions?.[0]?.amount || 0
  const comment = transaction.comment

  return (
    <TransactionReverseForm
      {...props}
      values={{
        amount,
        comment,
      }}
    />
  )
}
